const translations = {
  "en": {
    "Crypto For You": "Crypto For You",
    "Stock For You": "Stock For You"
  },
  "zh-tw": {
    "Crypto For You": "加密貨幣為你",
    "Stock For You": "為你準備的股票"
  }
};

export default translations;
